// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M4 1H20V5H18V3H6V17H18V15H20V23H4V1ZM13.0039 19H11V21.0039H13.0039V19Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M24 7H13V9H24V7Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M21 11H13V13H21V11Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-mobile-list-filled')
export default class MobileListFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'mobile-list-filled',
    }
  }
}
